import { extend } from 'vee-validate'

extend('phone_number', value => {
  if (new RegExp(/^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/gm).exec(value)) {
    return true
  }

  return 'not valid phone'
})
